
import React from 'react';
import Button from '../../../components/base/Button';

const HeroSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openZalo = () => {
    window.open('https://zalo.me/0961686191', '_blank');
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/0af2bc1e4f48fc49e1f1249d9633dcc2.jpg')`
      }}
    >
      <div className="container mx-auto px-4">
        <div className="w-full max-w-4xl">
          <div className="text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Giặt Ủi Minh Khôi<br />
              <span className="text-blue-400">Giặt sạch – Trả nhanh – Chuẩn khách sạn 5★</span>
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl">
              Dịch vụ giặt ủi chuyên nghiệp tại Đà Lạt, phục vụ khách sạn – spa – nhà hàng – hộ gia đình. 
              Cam kết giặt bằng nước nóng 70°C, hóa chất Ecolab nhập khẩu, giúp vải trắng sáng, mềm và thơm lâu.
            </p>

            <div className="flex flex-wrap gap-4 mb-8 text-lg">
              <div className="flex items-center bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
                <i className="ri-time-line text-teal-400 mr-2"></i>
                <span>Hoàn tất trong 24 giờ</span>
              </div>
              <div className="flex items-center bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
                <i className="ri-leaf-line text-green-400 mr-2"></i>
                <span>Tiết kiệm & thân thiện môi trường</span>
              </div>
              <div className="flex items-center bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
                <i className="ri-truck-line text-blue-400 mr-2"></i>
                <span>Đặt giặt tận nơi qua Zalo</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button 
                variant="primary" 
                size="lg"
                onClick={() => scrollToSection('booking')}
                className="text-lg px-8 py-4"
              >
                <i className="ri-calendar-check-line mr-2"></i>
                Đặt Giặt Ngay
              </Button>
              
              <Button 
                variant="secondary" 
                size="lg"
                onClick={openZalo}
                className="text-lg px-8 py-4"
              >
                <i className="ri-message-3-line mr-2"></i>
                Liên hệ Zalo 0961 686 191
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl">
              <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-drop-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Nước nóng 70°C</h3>
                  <p className="text-gray-200 text-sm">Hóa chất Ecolab tiêu chuẩn Mỹ</p>
                </div>
              </div>

              <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Chất lượng 5★</h3>
                  <p className="text-gray-200 text-sm">Chuẩn khách sạn cao cấp</p>
                </div>
              </div>

              <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-truck-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Giao nhận tận nơi</h3>
                  <p className="text-gray-200 text-sm">Lấy đồ MIỄN PHÍ</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
